export default "__VITE_ASSET__gcpOKIX3__"